export const redirectToLogin = () => {
    window.location.href = `/login?returnUrl=${encodeURIComponent(
        window.location.href.replace(`${window.location.protocol}//${window.location.host}`, '')
    )}`;
};
